import React from 'react';
import ValentinesPuzzle from '../components/ValentinesPuzzle';

// Import your Valentine's photos
// Replace these with your actual photo imports
import photo1 from '../assets/images/valentine/disney.jpg';
import photo2 from '../assets/images/valentine/disneynoche.jpg';
import photo3 from '../assets/images/valentine/johnpork.jpg';
import photo4 from '../assets/images/valentine/maxcisco.jpg';
import photo5 from '../assets/images/valentine/sandiegozoo.jpg';
import photo6 from '../assets/images/valentine/chongoballs.jpg';
// Add more imports as needed

const ValentinePage: React.FC = () => {
  // Array of all your Valentine's photos
  const valentineImages = [
    photo1,
    photo2,
    photo3,
    photo4,
    photo5,
    photo6
    // Add more photos here
  ];

  return (
    <div className="valentine-page">
      <ValentinesPuzzle 
        imageUrls={valentineImages}
        difficulty="5x5" // Default difficulty: '5x5', '7x7', '10x10', '20x20'
      />
    </div>
  );
};

export default ValentinePage;
